import { Card } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

interface MetricCardWithDetailsProps {
  title: string;
  value: string;
  change?: number;
  trend?: 'up' | 'down' | 'neutral';
  metricType: 'mrr' | 'arr' | 'churn' | 'revenue' | 'cac' | 'ltv' | 'average_ticket';
  filters: {
    productId?: string;
    startDate: Date;
    endDate: Date;
  };
}

export function MetricCardWithDetails({
  title,
  value,
  change,
  trend,
}: MetricCardWithDetailsProps) {
  const getTrendIcon = () => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4" />;
    return <Minus className="h-4 w-4" />;
  };

  const getTrendColor = () => {
    const metricType = title.toLowerCase().includes('churn') ? 'churn' : 'other';
    
    if (metricType === 'churn') {
      if (trend === 'down') return 'text-success';
      if (trend === 'up') return 'text-destructive';
    } else {
      if (trend === 'up') return 'text-success';
      if (trend === 'down') return 'text-destructive';
    }
    return 'text-muted-foreground';
  };

  return (
    <Card className="p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <p className="text-3xl font-bold tracking-tight">{value}</p>
          {change !== undefined && (
            <div className={`flex items-center gap-1 mt-2 text-sm font-medium ${getTrendColor()}`}>
              {getTrendIcon()}
              <span>{change > 0 ? '+' : ''}{change.toFixed(1)}%</span>
              <span className="text-xs text-muted-foreground ml-1">vs período anterior</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
